import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-pink-100 via-white to-pink-50 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-extrabold text-pink-600 mb-4 drop-shadow">
          404
        </h1>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Página no encontrada
        </h2>
        <p className="text-gray-600 mb-6">
          Lo sentimos, la página que buscas no existe o fue movida.
        </p>
        <Link
          to="/"
          className="inline-block bg-pink-600 hover:bg-pink-700 text-white font-semibold px-6 py-3 rounded-lg shadow transition"
        >
          Volver al Inicio
        </Link>
      </div>

    </div>
  );
};

export default NotFound;
